// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__2maLy","title":"AfterImages90_title__2R0XE","images":"AfterImages90_images__2KTB8"};